import { useTheme } from '@material-ui/core'
import React from 'react'
import { ReactComponent as Logo } from '../../assets/EZ_turn.svg'

import { Container } from '../../components'
import { typographyStyle } from '../../theme/typographyStyle'

export const ComingSoon = () => {
    const theme = useTheme()

    return (
        <Container
            flex={1}
            alignItems="center"
            justifyContent="center"
            direction="column"
        >
            <Logo
                fill={theme.palette.primary.main}
                style={{ height: 400, width: 400 }}
            />
            <span
                style={{
                    ...typographyStyle(theme.typography.h1),
                    fontWeight: 700,
                    width: 400,
                    textAlign: 'center',
                }}
            >
                Coming Soon!
            </span>
        </Container>
    )
}
